import { render } from "./VoiceCard.vue?vue&type=template&id=4e04e09e&scoped=true&ts=true"
import script from "./VoiceCard.vue?vue&type=script&lang=ts"
export * from "./VoiceCard.vue?vue&type=script&lang=ts"

import "./VoiceCard.vue?vue&type=style&index=0&id=4e04e09e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e04e09e"]])

export default __exports__